import type { OfflineSessionSnapshot } from '@/domain';
import type { OfflineSessionStatus, StationId } from '@/domain/types';
import type { OfflineQueueRepository } from '@/persistence/ports';
import type { Evse3Database } from '../db';

export class OfflineQueueRepositoryDexie implements OfflineQueueRepository {
  constructor(private readonly db: Evse3Database) {}

  async byStation(stationId: StationId): Promise<readonly OfflineSessionSnapshot[]> {
    const rows = await this.db.offlineQueue.where('stationId').equals(stationId).toArray();
    return rows.map(stripStation);
  }

  async byStatus(
    stationId: StationId,
    status: OfflineSessionStatus,
  ): Promise<readonly OfflineSessionSnapshot[]> {
    const rows = await this.db.offlineQueue
      .where('[stationId+status]')
      .equals([stationId, status])
      .toArray();
    return rows.map(stripStation);
  }

  async upsert(stationId: StationId, snap: OfflineSessionSnapshot): Promise<void> {
    await this.db.offlineQueue.put({ stationId, ...snap });
  }

  async delete(stationId: StationId, queueId: string): Promise<void> {
    await this.db.offlineQueue.delete([stationId, queueId]);
  }
}

function stripStation(
  row: OfflineSessionSnapshot & { stationId: StationId },
): OfflineSessionSnapshot {
  const { stationId: _s, ...rest } = row;
  return rest;
}
